import { HttpError } from "./HttpError";
import { InvalidModelMessage } from "./InvalidModelMessage";

export class ApiError extends HttpError {
    constructor(public readonly errors: InvalidModelMessage[]) {
        super(400, "");
    }
}